// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","324":"cf12e971","491":"5227ff75","514":"78fee3b4","995":"ee73ee9e"}[chunkId] + ".js";
};